export const closeSelectMixin = {
  methods: {}
};
